import React from 'react';
import s from './marker-shop.module.css';

const MarkerShop = ({ name, isOpen, onClick }) => {
	return (
		<div
			onClick={onClick}
			className={`hint hint--html hint--info hint--top ${s.container}`}
			style={{ position: 'absolute', transform: 'translate(-50%, -50%)' }}
			onDoubleClick={e => e.stopPropagation()}
			onMouseDown={e => e.stopPropagation()}
			onPointerDown={e => e.stopPropagation()}
			onTouchStart={e => e.stopPropagation()}
		>
			{!isOpen ? (
				<div className={s.containerClosed} />
			) : (
				<div className={s.containerOpened}>{name}</div>
			)}
		</div>
	);
};
export default MarkerShop;
